import React from 'react'
import './Iqac.css'
import imagese1 from "../Home/images/IMG_20230513_095610.jpg"
const IQAC = () => {
  return (
    <div data-aos="fade-up">
    <div className='main-conatiner-iqac'>
        <div className='conatiner-iqac-image-1'>
           {/* <img className='conatiner-iqac-image' src={imagese1} alt="image" />  */}
        </div>
        </div>
<div data-aos="fade-up">

        <div className='conatiner-iqac-About'>
        <h1>About</h1> <br />   
        <p className='para-about-iac'>The Internal Quality Assurance Cell (IQAC) at the college was established on 1st August 2011 as part of post-accreditation quality sustenance initiatives. Constituted in alignment with recommendations from the National Assessment and Accreditation Council (NAAC), the IQAC plays a central role in ensuring effective quality implementation through regular reviews and periodic meetings. <br /> <br />
        <h2>Objective</h2>
        1.	Academic and Administrative Performance: The IQAC aims to develop a system of conscious, consistent, and catalytic action that enhances both academic and administrative performance. <br /> <br />
        2.	Quality Enhancement and Best Practices: By fostering a quality culture and institutionalizing best practices, IQAC promotes key measures for improving institutional functionality in line with quality enhancement. <br /> <br />
        These objectives help the institution uphold a continuous improvement process, reinforcing quality standards in all academic and administrative domains.</p>
        </div>
    
    </div>
    </div>
  )
}

export default IQAC;